import React from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import Header from '../components/Header/Header';
import HeroSection from '../components/LandingPage/HeroSection';
import FeaturesSection from '../components/LandingPage/FeaturesSection';
import CTASection from '../components/LandingPage/CTASection';
import Footer from '../components/Footer/Footer';
import theme from '../styles/theme';

const LandingPage: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box>
        <Header />
        <HeroSection />
        <FeaturesSection />
        <CTASection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default LandingPage; 